export const REQUEST_EDITTEAMDATA = 'REQUEST_EDITTEAMDATA';
export const EDITTEAMDATA_RECEIVED = 'EDITTEAMDATA_RECEIVED';
export const CLEAR_EDITTEAMDATA = 'CLEAR_EDITTEAMDATA'

